import React from "react";
import { Box } from "@mui/material";
import SkeletonGallery from "./skeletonGallery";
import Gallery from "./gallery";
import { AddPhotoAlternate } from "@mui/icons-material";
import { useColorMode } from "../ColorModeContext";


interface GalleryPanelProps {
  galleryImages: string[];
  deleteImage: (index: number) => void;
  downloadImage: (img: string) => void;
}

const GalleryPanel: React.FC<GalleryPanelProps> = ({ galleryImages, deleteImage, downloadImage }) => {
const {colorMode} = useColorMode();
  return (
    <div style={{marginRight:"2vh"}}>
      {/* Title */}
      <div className="Title">
        <h1 className={colorMode?"TopNumberDark":"TopNumberLight"}>5</h1>
        <h1 className="Title">Gallery</h1>
      </div>
      <h4 className="SubTitle" style={{margin:'0'}}>Add renderings to the gallery by clicking on <AddPhotoAlternate/></h4>

      <Box flex="1" style={{ height: "81vh", overflow: "auto", paddingRight:'2vh' }}>
        {galleryImages.length === 0 ? (
          <>
            <h5 style={{ margin: 0 }}>Your gallery is currently empty...</h5>
            <SkeletonGallery />
            <SkeletonGallery />
            <SkeletonGallery />
            <SkeletonGallery />
          </>
        ) : (
          <Gallery images={galleryImages} onDeleteImage={deleteImage} onDownloadImage={downloadImage} />
        )}
      </Box>
    </div>
  );
};

export default GalleryPanel;
